// import logo from './logo.svg';
import { BrowserRouter, Switch, Route, Redirect, Link } from "react-router-dom";
import 'configurable-date-input-polyfill';
import { Button, ButtonGroup } from 'reactstrap';

import './App.css';
import BillTracker from './components/bill/BillTracker'
import AddBillTracker from './components/bill/AddBillTracker';
import BillReport from './components/bill/BillReport';

const App = () => {

  return (
    //  <div className='container'>
    //    <button class='btn btn-info'>Test</button>
    //  </div>
    <BrowserRouter>
      <div className='container-width'>
        <div className='row mt-5'>

          <div className='col-md-12 btmenu'>

            <ButtonGroup className='float-right tracker-btns'>
              <Link className='btn btn-sm btn-outline-success' to='/tracker/'>
                <i className="far fa-calendar-alt"></i>
              </Link>

              <Link className='btn btn-sm btn-outline-success' to='/tracker/report'>
                <i className="fa fa-table" aria-hidden="true"></i>
              </Link>

            </ButtonGroup>
          </div>
          <br /> <br />


          <div className='col-md-12'>
            <Switch>
              <ProtectedRoute exact path="/tracker/add" component={AddBillTracker}></ProtectedRoute>
              <Route exact path="/tracker/" render={props => <BillTracker {...props} />} />
              <Route exact path="/tracker/rifoti/:period" render={props => <BillTracker {...props} />} />
              <Route exact path="/tracker/report" component={BillReport} />
            </Switch>
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;

const ProtectedRoute = ({ component: Component, ...rest }) => {
  let sessUser = sessionStorage.getItem('uemail')
  // sessUser = 'testing'
  
  return (
    <Route {...rest} render={
      props => sessUser && sessUser !== '' ? ( //localStorage.getItem('user')
        <Component {...props} />
      ) : (
          <Redirect
            to={{
              pathname: "/tracker/",
              // state: { from: props.location }
            }}
          />
        )
    }
    />
  )
}
